module.exports = __webpack_public_path__ + "img/xy_control_line.5b668d95.svg";